import { validateNumber } from 'ember-changeset-validations/validators';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { type ValidatorResult } from 'ember-changeset-validations';
import { validateIsModuleOf } from 'uplisting-frontend/validators/is-module-of';

export const PropertyDiscountRulValidation = {
  priceChange: validateNumber({ gte: 0, lte: 99 }),

  thresholdOne: function (
    key: string,
    newValue: unknown,
    oldValue: unknown,
    changes: Record<string, unknown>,
    content: Record<string, unknown>,
  ): ValidatorResult {
    const rule = content as unknown as ModelRegistry['property-discount-rule'];

    if (rule.isLastMinuteDiscountRule) {
      return validateNumber({ gte: 0, lte: 28 })(
        key,
        newValue,
        oldValue,
        changes,
        content,
      );
    } else if (rule.isEarlyBirdDiscountRule) {
      const isValid = validateIsModuleOf([28, 30])(
        key,
        newValue,
        oldValue,
        changes,
        content,
      );

      if (!isValid) {
        return 'error';
      }

      return true;
    }

    return true;
  },
};
